import React, { useState } from "react";
import MuiTableCell from "@material-ui/core/TableCell";
import { withStyles } from "@material-ui/core/styles";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ScreenLoader from "../../../../Common/Loader";
import {HRlang} from "../../../../Common/Languages";
import {
  Divider,
  Table,
  TableHead,
  TableRow,
  TableSortLabel,
  TableBody,
  Collapse,
  Grid,
  TableContainer,
	Paper,
} from "@material-ui/core";
import useStyles from "../Style/style";

const TableCell = withStyles({
  root: {
    borderBottom: "none",
  },
})(MuiTableCell);

const AvgSalaryDepartment = (props) => {
  const classes = useStyles();
  const [collapse, setCollapse] = useState(false);
  var rowCount = 0;

  const handleArrowClick = () => {
    setCollapse(!collapse);
  };

  const lang = localStorage.getItem("languages");

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={12} className={classes.gridItem}>
          <Grid
            container
            spacing={3}
            alignItems="center"
            className={classes.collapse}
          >
            <Grid item xs={11}>
              <span className={classes.title}>
                {HRlang.AVERAGESALARYPERDEPARTMENT[lang]}
              </span>
            </Grid>
            <Grid item xs={1} className={classes.icons}>
              {(collapse && (
                <ArrowDropDownIcon
                  fontSize="default"
                  className={classes.collapseButton}
                  onClick={handleArrowClick}
                />
              )) || (
                <ArrowDropUpIcon
                  fontSize="default"
                  className={classes.collapseButton}
                  onClick={handleArrowClick}
                />
              )}
            </Grid>
          </Grid>
          <Divider
            classes={{ root: classes.dividers }}
            component="hr"
            orientation="horizontal"
          />
        </Grid>
        {props.salaryData ? (
          <Collapse in={!collapse}>
            <Grid item xs={12} className={classes.tableGrid}>
              <TableContainer
                component={Paper}
                classes={{ root: classes.tableContainer }}
              >
                <Table
                  stickyHeader
                  aria-label="simple table"
                  className={classes.table}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="left"
                        className={`${classes.ellipsis} ${classes.tableHeader}`}
                      >
                        <TableSortLabel>{HRlang.DEPARTMENT[lang]}</TableSortLabel>
                      </TableCell>
                      <TableCell
                        align="left"
                        className={`${classes.ellipsis} ${classes.tableHeader}`}
                      >
                        {HRlang.AVERAGESALARY[lang]}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {props.salaryData.map((row) => {
                      rowCount = rowCount + 1;
                      return (
                        <TableRow
                          id="tableRow"
                          key={row.id}
                          className={classes.tableRow}
                        >
                          <TableCell
                            className={`${classes.ellipsis} ${classes.tableCell}`}
                            component="td"
                            scope="row"
                          >
                            {row.department}
                          </TableCell>
                          <TableCell
                            className={`${classes.tableCell} ${classes.ellipsis}`}
                            component="td"
                            scope="row"
                          >
                            {row.avg}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Collapse>
        ) : (
          <ScreenLoader />
        )}
      </Grid>
    </div>
  );
};
export default AvgSalaryDepartment;
